import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Product } from "../../models/product.model";
import { Receipt } from "../../models/receipt.model";
import Shop from "../../models/shop.model";

import { ReceiptService } from "../../services/receipt.service";

@Component({
  selector: "ngx-dialog-print-product-barcode",
  templateUrl: "dialog-print-product-barcode.component.html",
  styleUrls: ["dialog-print-product-barcode.component.scss"],
})
export class DialogPrintProductBarcodeComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() shop?: Shop;
  @Input() product?: Product;

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  showPrinter = true;
  submitted: boolean = false;
  quantity = 1;
  numbers = [1];

  constructor(protected ref: NbDialogRef<DialogPrintProductBarcodeComponent>) {}

  ngOnInit() {
    this.generator();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.generator();
    }, 1000);
  }

  generator() {
    this.numbers = _.range(this.quantity);
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.showPrinter = false;
    setTimeout(() => {
      let el: HTMLElement = this.printBtn.nativeElement;
      el.click();

      this.ref.close(true);
    });
  }
}
